import { render } from "./MobileBottomPlayer.vue?vue&type=template&id=0590c7ee&scoped=true"
import script from "./MobileBottomPlayer.vue?vue&type=script&lang=js"
export * from "./MobileBottomPlayer.vue?vue&type=script&lang=js"

import "./MobileBottomPlayer.vue?vue&type=style&index=0&id=0590c7ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0590c7ee"]])

export default __exports__